module.exports = __webpack_public_path__ + "static/media/school_01.93ffe0cf.webp";